import { Injectable } from '@angular/core';
import { marked } from 'marked';

@Injectable({
    providedIn: 'root',
})
export class DatiqTemplateMdMarkedService {
    constructor() {}

    render(md: string): string {
        return marked(md);
    }
}
